import { TextWidth, TextWidthExtended } from 'components/Container'
import { useState } from 'react'
import ReactPlayer from 'react-player'
import { Waypoint } from 'react-waypoint'
import styled from 'styled-components'

const _ReactVideo = styled.figure`
  width: 100%;
  display: inline-block;
  line-height: 0;
  position: relative;
  margin: 0;
  @media only screen and (max-width: 600px) {
    margin-left: 0;
  }
  img {
    width: 100%;
  }
  .video {
    height: 100%;
    -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
  }
  .aspect {
    width: 100%;
    display: inline-block;
    aspect-ratio: 16/9;
  }
  .placeholder {
    position: relative;
    &::after {
      position: absolute;
      top: calc(50% - 60px);
      left: calc(50% - 30px);
      content: '';
      width: 20px;
      height: 0;
      border-top: 60px solid transparent;
      border-bottom: 60px solid transparent;
      border-left: 90px solid rgba(255, 255, 255, 0.9);
    }
  }
  margin-bottom: 30px;
  margin-bottom: 60px;
`

export const ReactVideo = ({
  videoUrls,
  placeholder,
  title,
  caption,
  source,
}: {
  videoUrls: string[]
  placeholder: string
  title?: string
  caption?: string
  source?: string
}) => {
  const [showPlaceholder, setShowPlaceholder] = useState(true)

  return (
    <_ReactVideo className='ReactVideo'>
      <TextWidthExtended>
        <div className='aspect'>
          {showPlaceholder && (
            <div
              className='placeholder'
              onClick={() => setShowPlaceholder(false)}
            >
              <img src={placeholder} />
            </div>
          )}

          {!showPlaceholder && (
            <div className='video'>
              <ReactPlayer
                playing={!showPlaceholder}
                playsinline
                width='100%'
                height='100%'
                controls
                url={videoUrls}
              />
            </div>
          )}
        </div>
        <Waypoint
          scrollableAncestor={window}
          onLeave={(e) => setShowPlaceholder(true)}
        />
      </TextWidthExtended>
      <TextWidth>
        <FigCaption>
          {title && <Title>{title}</Title>}
          {caption && <Caption>{caption}</Caption>}
          {source && <Source>{source}</Source>}
        </FigCaption>
      </TextWidth>
    </_ReactVideo>
  )
}

const FigCaption = styled.figcaption`
  padding-top: 1.5rem;
  font-size: 15px;
  line-height: 21px;
  color: var(--text-color);
`
const Title = styled.div`
  font-weight: 700;
`
const Caption = styled.div``
const Source = styled.div`
  font-size: 12px;
  line-height: 18px;
`
